import React from 'react';
import AccordionWithIconPreview from '../../../../components/ui-builder/component-preview/accordion-with-icon/Accordion-With-Icon-Preview';
import AccordionWithoutIconPreview from '../../../../components/ui-builder/component-preview/accordion-without-icon/Accordion-Without-Icon-Preview';
import CarouselSocialComponentPreview from '../../../../components/ui-builder/component-preview/carousel-social-component/Carousel-Social-Component-Preview';
import CarousalWithoutBackgroundPreview from '../../../../components/ui-builder/component-preview/carousel-without-background/Carousel-Without-Background';
import CtaButton1Preview from '../../../../components/ui-builder/component-preview/cta-button-1/Cta-Button-1-Preview';
import DetailViewPreview from '../../../../components/ui-builder/component-preview/detail-view/Detail-View-Preview';
import HeroBannerWithCTAPreview from '../../../../components/ui-builder/component-preview/hero-banner-with-cta/Hero-Banner-With-CTA-Preview';
import HeroBannerWithTitleAndCtaPreview from '../../../../components/ui-builder/component-preview/hero-banner-with-title-and-cta/Hero-Banner-With-Title-And-Cta-Preview';
import HeroBannerWithTitlePreview from '../../../../components/ui-builder/component-preview/hero-banner-with-title/Hero-Banner-With-Title-Preview';
import ImageComponentWithTitleAndBodyPreview from '../../../../components/ui-builder/component-preview/image-component-with-title-and-body/Image-Component-With-Title-And-Body';
import LandscapeCarousalWithBackgroundPreview from '../../../../components/ui-builder/component-preview/landscape-carousel-with-background/Landscape-Carousel-With-Background';
import LandscapeCarouselWithBodyCTAPreview from '../../../../components/ui-builder/component-preview/landscape-carousel-with-body-cta/Landscape-Carousel-With-Body-CTA-Preview';
import LargeImageCarousalWithBackgroundPreview from '../../../../components/ui-builder/component-preview/large-image-carousal-with-background/Large-Image-Carousal-With-Background';
import LargeImageComponentWithBackgroundPreview from '../../../../components/ui-builder/component-preview/large-image-component-with-background/Large-Image-Component-With-Background';
import LargeImageComponentWithBodyPreview from '../../../../components/ui-builder/component-preview/large-image-component-with-body/Large-Image-Component-With-Body';
import LargeImageComponentWithBodyAndBackgroundPreview from '../../../../components/ui-builder/component-preview/large-image-component-with-title-subtitle-body/Large-Image-Component-With-Title-Subtitle-Body';
import LargeImageComponentPreview from '../../../../components/ui-builder/component-preview/large-image-component/Large-Image-Component';
import ListComponentPreview from '../../../../components/ui-builder/component-preview/list-component/List-Component-Preview';
import PortraitCarousalWithBackgroundPreview from '../../../../components/ui-builder/component-preview/portrait-carousal-with-background/Portrait-Carousal-With-Background-Preview';
import ServiceDetailPagePreview from '../../../../components/ui-builder/component-preview/service-detail-page/Service-Detail-page-Preview';
import SmallWithTitlePreview from '../../../../components/ui-builder/component-preview/small-banner-with-title/Small-Banner-With-Title-Preview';
import {
  ACCORDION_WO_ICON,
  ACCORDION_W_ICON,
  BUTTON_W_CTA,
  BUTTON_W_ICON,
  CAROUSEL_LANDSCAPE_W_BG,
  CAROUSEL_LANDSCAPE_W_BODY_CTA,
  CAROUSEL_LARGE_IMG_W_BG,
  CAROUSEL_PORTRAIT_W_BG,
  CAROUSEL_SOCIAL,
  CAROUSEL_WO_BG,
  DETAIL_PAGE,
  HERO_BANNER_W_CTA,
  HERO_BANNER_W_SUBTITLE_CTA,
  HERO_BANNER_W_TITLE,
  IMAGE_LARGE,
  IMAGE_LARGE_W_BG,
  IMAGE_LARGE_W_TITLE_BODY,
  IMAGE_LARGE_W_TITLE_SUBTITLE_BODY,
  IMAGE_W_TITLE_BODY,
  LIST_COMPONENT,
  SERVICE_DETAIL_COMPONENT,
  SMALL_BANNER_W_TITLE,
  BASIC_TEXT_COMPONENT,
  CAROUSEL_W_DESCRIPTION,
} from '../../../../constants/UiBuilderConst';
import ButtonWithIconPreview from '../../../../components/ui-builder/component-preview/button-with-icon/Button-with-Icon-Preview';
import BasicTextComponentPreview from '../../../../components/ui-builder/component-preview/basic-text-component/Basic-Text-Component-Preview';
import CarousalWithDescriptionPreview from '../../../../components/ui-builder/component-preview/carousel-with-description/Carousel-With-Description';

const PageBuilderPreview = (props) => {
  const { components } = props;

  const switchComponent = (component) => {
    switch (component.id) {
      case CAROUSEL_PORTRAIT_W_BG:
        return <PortraitCarousalWithBackgroundPreview config={component.config} />;
      case CAROUSEL_WO_BG:
        return <CarousalWithoutBackgroundPreview config={component.config} />;
      case CAROUSEL_LANDSCAPE_W_BG:
        return <LandscapeCarousalWithBackgroundPreview config={component.config} />;
      case CAROUSEL_W_DESCRIPTION:
        return <CarousalWithDescriptionPreview config={component.config} />;
      case CAROUSEL_LARGE_IMG_W_BG:
        return <LargeImageCarousalWithBackgroundPreview config={component.config} />;
      case HERO_BANNER_W_CTA:
        return <HeroBannerWithCTAPreview config={component.config} />;
      case IMAGE_W_TITLE_BODY:
        return <ImageComponentWithTitleAndBodyPreview config={component.config} />;
      case IMAGE_LARGE_W_TITLE_BODY:
        return <LargeImageComponentWithBodyPreview config={component.config} />;
      case IMAGE_LARGE_W_BG:
        return <LargeImageComponentWithBackgroundPreview config={component.config} />;
      case IMAGE_LARGE:
        return <LargeImageComponentPreview config={component.config} />;
      case IMAGE_LARGE_W_TITLE_SUBTITLE_BODY:
        return <LargeImageComponentWithBodyAndBackgroundPreview config={component.config} />;
      case HERO_BANNER_W_SUBTITLE_CTA:
        return <HeroBannerWithTitleAndCtaPreview config={component.config} />;
      case HERO_BANNER_W_TITLE:
        return <HeroBannerWithTitlePreview config={component.config} />;
      case SMALL_BANNER_W_TITLE:
        return <SmallWithTitlePreview config={component.config} />;
      case ACCORDION_W_ICON:
        return <AccordionWithIconPreview config={component.config} />;
      case ACCORDION_WO_ICON:
        return <AccordionWithoutIconPreview config={component.config} />;
      case BUTTON_W_CTA:
        return <CtaButton1Preview config={component.config} />;
      case CAROUSEL_LANDSCAPE_W_BODY_CTA:
        return <LandscapeCarouselWithBodyCTAPreview config={component.config} />;
      case CAROUSEL_SOCIAL:
        return <CarouselSocialComponentPreview config={component.config} />;
      case LIST_COMPONENT:
        return <ListComponentPreview config={component.config} />;
      case DETAIL_PAGE:
        return <DetailViewPreview config={component.config} />;
      case SERVICE_DETAIL_COMPONENT:
        return <ServiceDetailPagePreview config={component.config} />;
      case BUTTON_W_ICON:
        return <ButtonWithIconPreview config={component.config} />;
      case BASIC_TEXT_COMPONENT:
        return <BasicTextComponentPreview config={component.config} />;
      default:
        return <div></div>;
    }
  };

  return (
    <div className='page-builder-preview-window scroll-styled'>
      {components.map((component, key) => (
        <div key={key}>{switchComponent(component)}</div>
      ))}
    </div>
  );
};

export default PageBuilderPreview;
